import { ReactNode, useState } from 'react'
import JoyRide, { BeaconRenderProps } from 'react-joyride'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import styled from 'styled-components'
import { DivHelp } from './styles'
import { colors } from '../../theme'

type StepsProps = {
  content: ReactNode
  disableBeacon?: boolean
  event?: string
  hideFooter?: boolean
  isFixed?: boolean
  offset?: number
  target: string | HTMLElement
  title?: ReactNode
}

type TourProps = {
  steps: Array<StepsProps>
}

export function Tour({ steps }: TourProps) {
  const [tour, setTour] = useState(false)

  const HiddenBeacon = styled.div`
    display: none;
  `
  return (
    <>
      <div>
        {tour ? (
          <JoyRide
            continuous
            hideCloseButton
            scrollToFirstStep
            steps={steps}
            locale={{
              back: 'Voltar',
              close: 'Fechar',
              last: 'Finalizar',
              next: 'Próximo',
              open: 'Open the dialog',
              skip: 'Pular',
            }}
            beaconComponent={
              HiddenBeacon as React.ElementType<BeaconRenderProps>
            }
            styles={{
              options: {
                // A seta acompanha o balao; e `textColor` e obrigatorio: sem
                // ele o react-joyride cai no default #333, cinza-escuro sobre
                // a superficie escura do balao.
                arrowColor: `${colors.surface}`,
                textColor: `${colors.grey900}`,
                backgroundColor: `${colors.surface}`,
                overlayColor: `${colors.overlay}`,
                primaryColor: `${colors.secondary}`,
                width: 300,
                zIndex: 1000,
                beaconSize: 1,
              },
            }}
          />
        ) : (
          ''
        )}
      </div>
      <DivHelp onClick={() => setTour(!tour)}>
        {/* <FontAwesomeIcon icon={faCircleQuestion} /> */}
      </DivHelp>
    </>
  )
}
